// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__10tko","column":"style_column__3zSAL","row":"style_row__Yh3Ym"};